import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import {List, ListItem, ListItemText, Hidden, Collapse} from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import _ from "lodash";
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';

import {
    selectStation, fetchNotes, getVisitsInfo,
    newNoteAdded, fetchingData, checkInStation, clearStationSelection, selectArea, selectZone,
    filterArea, filterStation, filterZone
} from "../../../actions/visits_actions";
import VerticalAlign from "../../../components/verticalAlign/VerticalAlign";
import LoadingSpinner from "../../../components/spinner/Spinner";
import './styles.scss';


class StationSidebar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            stations: false,
            zones: false,
            search: ''
        }
    }

    componentDidMount() {
        if (this.props.areas.list) {
            let keysAreas = Object.keys(this.props.areas.list);
            if (keysAreas.length > 0) {
                if (!this.props.mobile.isMobile) {
                    this.props.filterArea(parseInt(keysAreas[0], 10));
                    this.props.selectArea(keysAreas[0]);
                } else {
                    this.props.filterArea(parseInt(keysAreas[0], 10));
                }
                this.findZonesStations(keysAreas[0]);
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.stations.list) {
            let keys = Object.keys(nextProps.stations.list);
            let keysAreas = Object.keys(nextProps.areas.list);

            if (!this.props.stations.list && keys.length > 0) {
                if (!this.props.mobile.isMobile) {
                    this.props.selectStation(nextProps.stations.list[keys[0]].id);
                    this.props.fetchingData();
                    this.props.fetchNotes(nextProps.stations.list[keys[0]].id);
                    this.props.getVisitsInfo(nextProps.stations.list[keys[0]].id);
                    this.props.selectArea(keysAreas[0]);
                }
                this.props.filterArea(parseInt(keysAreas[0], 10));
                this.props.checkInStation(false);
                this.props.newNoteAdded();

            } else if (nextProps.areas.filteredArea &&
                nextProps.areas.filteredArea !== "0" &&
                nextProps.areas.filteredArea !== this.props.areas.filteredArea) {
                this.findZonesStations(nextProps.areas.filteredArea);
            } else if (nextProps.zones.filteredZone
                && nextProps.zones.filteredZone !== "0" &&
                nextProps.zones.filteredZone.toString() !== this.props.zones.filteredZone) {
                this._getSelectedZoneStations(nextProps.zones.filteredZone);
            }
        }

    }

    findZonesStations = (area) => {
        let areaZones = this._getSelectedAreaZones(area);
        let keys = Object.keys(areaZones);

        if (areaZones[keys[0]]) {
            let zone = areaZones[keys[0]].id;
            let zoneStations = this._getSelectedZoneStations(zone);
            let keysStations = Object.keys(zoneStations);
            this.props.filterZone(zone);
            this.props.filterStation(zoneStations[keysStations[0]].id);
            if (!this.props.mobile.isMobile) {
                this.props.selectZone(zone);
            }

            this.setState({
                zones: areaZones,
                stations: zoneStations,
            });
        }

    };

    handleChange = (ev) => {
        if(ev.target.value==='' && this.props.stations.list){
            let keys = Object.keys(this.props.stations.list);
            this.props.filterStation(this.props.stations.list[keys[0]].id);
            if(!this.props.mobile.isMobile){
                this.props.selectStation(this.props.stations.list[keys[0]].id);
            }
        }
        this.setState({search: ev.target.value})
    };

    _handleListItemClick = (event, index) => {
        this.props.selectStation(index);
        this.props.filterStation(index);
        this.props.fetchingData();
        this.props.fetchNotes(index);
        this.props.getVisitsInfo(index);
        this.props.checkInStation(false);
        this.props.newNoteAdded();
    };

    _handleListAreaClick = (event, index) => {
        event.preventDefault();
        event.stopPropagation();
        this.props.clearStationSelection();
        this.props.filterArea(index.toString() !== this.props.areas.filteredArea.toString() ? index : "0");
    };

    _handleListZoneClick = (event, index) => {
        event.preventDefault();
        event.stopPropagation();
        this.props.clearStationSelection();
        this.props.filterZone(index.toString() !== this.props.zones.filteredZone.toString() ? index : "0");
    };

    _getSelectedAreaZones = (areaId) => {
        let {zones} = this.props;
        let areaZones = _.filter(zones.list, (zone) => {
            return zone.area === parseInt(areaId, 10)
        });
        this.setState({zones: areaZones});
        return areaZones;

    };

    _getSelectedZoneStations = (zoneId) => {
        let {stations} = this.props;
        let zoneStations = _.filter(stations.list, (station) => {
            return station.zone === zoneId;
        });
        this.setState({stations: zoneStations});
        return zoneStations;

    };

    _fetchZoneNotes = (areaId, zoneId) => {
        this.props.fetchingData();
        this.props.selectArea(areaId);
        this.props.selectZone(zoneId);
        this.props.filterArea(areaId);
        this.props.filterZone(zoneId);
        this.props.filterStation(0);
        this.props.fetchNotes(null, areaId, zoneId);
        this.props.clearStationSelection();

    };

    _fetchAreaNotes = (areaId) => {
        this.props.fetchingData();
        this.props.selectArea(areaId);
        this.props.filterArea(areaId);
        this.props.fetchNotes(null, areaId);
        this.props.filterStation(0);
        this.props.filterZone("0");
        this.props.clearStationSelection();
    };

    _filterConditions = (s) => {
        let {search} = this.state;
        search = search.toUpperCase();
        return s.global_code.toString().includes(search) || s.address.includes(search) || s.company.name.includes(search) || s.city.includes(search);
    };

    _renderRow = () => {
        if (this.state.search !== '') {
            let filteredStations = this.state.search !== '' ? _.filter(this.props.stations.list, this._filterConditions) : this.props.stations.list;

            return _.map(filteredStations, (station) => {
                let filteredStation = this.props.stations.filteredStation.toString() === station.id.toString();
                return (
                        <ListItem key={station.id.toString()}
                                  button
                                  className={filteredStation ? "list-item station active" : "list-item station"}
                                  onClick={event => this._handleListItemClick(event, station.id)}>
                            <ListItemText className={"station"}
                                          primary={`${station.global_code} - ${station.company.name} - ${station.city}`}/>
                        </ListItem>
                    )
            })
        } else {
            return _.map(this.props.areas.list, (area) => {
                let filteredArea = this.props.areas.filteredArea.toString() === area.id.toString();
                return (<List disablePadding>
                        <ListItem key={area.id.toString()}
                                  button
                                  className={filteredArea ? "list-item area active" : "list-item area"}
                                  selected={filteredArea}
                                  onClick={() => this._fetchAreaNotes(area.id)}>
                            <ListItemText primary={`${area.name}`}/>
                            {filteredArea ?
                                <ExpandLess onClick={event => this._handleListAreaClick(event, area.id)}/> :
                                <ExpandMore onClick={event => this._handleListAreaClick(event, area.id)}/>}
                        </ListItem>
                        {this.state.zones && this.state.stations && filteredArea &&
                        <Collapse in={filteredArea} timeout="auto"
                                  unmountOnExit>
                            {_.map(this.state.zones, (zone) => {
                                let filteredZone = this.props.zones.filteredZone.toString() === zone.id.toString();
                                return (
                                    <List component="div" disablePadding>
                                        <ListItem key={zone.id.toString()}
                                                  button
                                                  className={filteredZone ? "list-item zone active" : "list-item zone"}
                                                  selected={filteredZone}
                                                  onClick={() => this._fetchZoneNotes(area.id, zone.id)}>
                                            <ListItemText className={"zone"} primary={`${zone.name}`}/>
                                            {filteredZone ?
                                                <ExpandLess
                                                    onClick={event => this._handleListZoneClick(event, zone.id)}/> :
                                                <ExpandMore
                                                    onClick={event => this._handleListZoneClick(event, zone.id)}/>}
                                        </ListItem>
                                        {filteredZone &&
                                        <Collapse in={filteredZone}
                                                  timeout="auto" unmountOnExit>
                                            {_.map(this.state.stations, (station) => {
                                                let filteredStation = this.props.stations.filteredStation.toString() === station.id.toString();
                                                return (<ListItem key={station.id.toString()}
                                                                  button
                                                                  className={filteredStation ? "list-item station active" : "list-item station"}
                                                                  onClick={event => this._handleListItemClick(event, station.id)}>
                                                    <ListItemText className={"station"}
                                                                  primary={`${station.global_code} - ${station.company.name} - ${station.city}`}/>
                                                </ListItem>)
                                            })}
                                        </Collapse>}
                                    </List>
                                )
                            })}
                        </Collapse>}
                    </List>
                );

            });
        }
    };

    render() {
        return (
            <div className={'station-sidebar'}>
                <Hidden smUp>
                    <div className={'grey-banner'}>
                        Seleccione una boca
                    </div>
                </Hidden>
                <FormControl className={"search-section"}>
                    <Input
                        type={'text'}
                        value={this.state.search}
                        placeholder="Buscar"
                        onChange={this.handleChange}
                        endAdornment={
                            <InputAdornment position="end">
                                <i className="material-icons search">
                                    search
                                </i>
                            </InputAdornment>
                        }
                    />
                </FormControl>
                {this.props.areas.filteredArea && this.props.zones.filteredZone && this.state.stations && this.state.zones &&
                <List className={"list"}>
                    {this._renderRow()}
                </List>}
                {!this.props.stations.list &&
                <VerticalAlign>
                    <LoadingSpinner className={''} width={50}/>
                </VerticalAlign>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        stations: state.stations,
        areas: state.areas,
        zones: state.zones,
        mobile: state.mobile,
        visits: state.visits
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        selectStation,
        clearStationSelection,
        fetchNotes,
        getVisitsInfo,
        newNoteAdded,
        fetchingData,
        checkInStation,
        selectArea,
        selectZone,
        filterArea,
        filterStation,
        filterZone
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(StationSidebar);


// WEBPACK FOOTER //
// ./src/containers/site-visits/stationSidebar/StationSidebar.js